// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { DirectPropertyOwner } from '../../Utils/Enums/Constants';
import { Message } from './Message';
export class DirectPropertyMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_PFIX_PROPERTY_MESSAGE);
        this.OwnerType = DirectPropertyOwner.Unspecified;
        this.OwnerID = 0;
        this.Name = null;
        this.Value = null;
    }
}
